import React, { useEffect, useState } from "react";
import axios from "axios";

const AddNewYearGlobal = () => {
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [years, setYears] = useState([]);
  const [deleteYear, setDeleteYear] = useState(null);

  const currentYear = new Date().getFullYear();

  const getToken = () => {
    const userDetailsString = localStorage.getItem("userDetails");
    const userDetails = userDetailsString
      ? JSON.parse(userDetailsString)
      : null;
    return userDetails?.token || null;
  };

  const loadYears = async () => {
    try {
      const token = getToken();
      if (!token) {
        setError("Authorization token missing");
        return;
      }

      const res = await axios.get(
        `${process.env.REACT_APP_PREDICTIONS_API}/api/admin-prediction-years`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const list = Array.isArray(res.data?.years) ? res.data.years : [];
      setYears(list);
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Failed to load years";
      setError(msg);
    }
  };

  useEffect(() => {
    loadYears();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    const yearNumber = Number(year);

    if (!yearNumber || Number.isNaN(yearNumber)) {
      setError("Invalid year");
      return;
    }

    if (yearNumber <= currentYear) {
      setError(`You can add only future years (greater than ${currentYear})`);
      return;
    }

    try {
      setLoading(true);

      const token = getToken();
      if (!token) {
        setError("Authorization token missing");
        return;
      }

      const url = `${process.env.REACT_APP_PREDICTIONS_API}/api/admin-add-prediction-year/${yearNumber}`;

      const res = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccess(`Year ${yearNumber} added successfully`);
      setYear("");

      window.location.reload();

      await loadYears();
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Failed to add year";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteYear = async (y) => {
    setSuccess("");
    setError("");
    setDeleteYear(y);

    try {
      const token = getToken();
      if (!token) {
        setError("Authorization token missing");
        return;
      }

      const url = `${process.env.REACT_APP_PREDICTIONS_API}/api/admin-prediction-year/${y}`;

      const res = await axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSuccess(res.data?.message || `Year ${y} deleted`);
      setYears((prev) => prev.filter((yr) => yr !== y));
      window.location.reload();
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Failed to delete year";
      setError(msg);
    } finally {
      setDeleteYear(null);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="row">
      <div className="col-md-4 mb-3">
        <label className="form-label">New Year</label>
        <input
          type="number"
          className="form-control"
          placeholder={`e.g. ${currentYear + 1}`}
          min={currentYear + 1}
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />
      </div>

      <div className="col-md-4 mb-3 d-flex align-items-end">
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Saving..." : "Add Year to All Groups"}
        </button>
      </div>

      <div className="col-12">
        {error && <div className="text-danger small mt-1">{error}</div>}
        {success && <div className="text-success small mt-1">{success}</div>}
      </div>

      <div className="col-12 mt-3">
        <label className="form-label">Existing Years</label>
        <div className="d-flex flex-wrap gap-2">
          {years.length === 0 && (
            <span className="text-muted">No years yet</span>
          )}

          {years.map((y) => (
            <div
              key={y}
              className="badge bg-light text-dark border d-flex align-items-center px-2 py-1"
              style={{ fontSize: "0.9rem" }}
            >
              <span className="me-2">{y}</span>
              <button
                type="button"
                className="btn btn-sm btn-link text-danger p-0"
                onClick={() => handleDeleteYear(y)}
                disabled={deleteYear === y}
                aria-label={`Delete year ${y}`}
              >
                {deleteYear === y ? "…" : "✕"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </form>
  );
};

export default AddNewYearGlobal;
